import { hasAnyClass } from '../has-any-class';

export function hasAnyParentsWithClass(
	target: Node,
	classes: string[]
): boolean {
	if (target !== document.body) {
		if (hasAnyClass(target as Element, classes)) {
			return true;
		} else {
			return hasAnyParentsWithClass(target.parentNode, classes);
		}
	}
	return false;
}
